import { useState } from "react";

export function SafeImage({ src, alt = "", className = "", fallback = null, ...props }) {
  const [failed, setFailed] = useState(false);
  if (typeof src !== "string" || !src.trim() || failed) return fallback;
  return <img src={src} alt={alt} className={className} onError={() => setFailed(true)} {...props} />;
}
